/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OverrideRequest } from '../models/OverrideRequest';
import type { RestrictedWord } from '../models/RestrictedWord';
import type { RestrictedWordCheckRequest } from '../models/RestrictedWordCheckRequest';
import type { RestrictedWordMatch } from '../models/RestrictedWordMatch';
import type { RestrictedWordRequest } from '../models/RestrictedWordRequest';
import type { RestrictedWordResponse } from '../models/RestrictedWordResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DashboardRestrictedWordControllerService {
    /**
     * @returns RestrictedWord OK
     * @throws ApiError
     */
    public static updateRestrictedWord({
        restrictedWordId,
        requestBody,
    }: {
        restrictedWordId: number,
        requestBody: RestrictedWordRequest,
    }): CancelablePromise<RestrictedWord> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/restricted-words/{restrictedWordId}',
            path: {
                'restrictedWordId': restrictedWordId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static deleteRestrictedWord({
        restrictedWordId,
    }: {
        restrictedWordId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/restricted-words/{restrictedWordId}',
            path: {
                'restrictedWordId': restrictedWordId,
            },
        });
    }
    /**
     * @deprecated
     * @returns any OK
     * @throws ApiError
     */
    public static toggleRestrictedWord({
        restrictedWordId,
        state,
    }: {
        restrictedWordId: number,
        state: boolean,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/restricted-words/{restrictedWordId}/toggle/{state}',
            path: {
                'restrictedWordId': restrictedWordId,
                'state': state,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static overrideRestrictedWord({
        restrictedWordId,
        requestBody,
    }: {
        restrictedWordId: number,
        requestBody: OverrideRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/restricted-words/{restrictedWordId}/override',
            path: {
                'restrictedWordId': restrictedWordId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns RestrictedWordResponse OK
     * @throws ApiError
     */
    public static getRestrictedWords(): CancelablePromise<Array<RestrictedWordResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/restricted-words',
        });
    }
    /**
     * @returns RestrictedWord OK
     * @throws ApiError
     */
    public static createRestrictedWord({
        requestBody,
    }: {
        requestBody: RestrictedWordRequest,
    }): CancelablePromise<RestrictedWord> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/restricted-words',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns RestrictedWordMatch OK
     * @throws ApiError
     */
    public static checkMessage({
        requestBody,
    }: {
        requestBody: RestrictedWordCheckRequest,
    }): CancelablePromise<RestrictedWordMatch> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/restricted-words/check',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
